import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Card, Space, Table, Tag, Typography, message } from 'antd';
import { ApiOutlined, ReloadOutlined } from '@ant-design/icons';
import { mallAPI } from '../services/api';

const { Text } = Typography;
const T = {
  title: '\u652f\u4ed8\u63a5\u53e3\u914d\u7f6e',
  subtitle: '\u652f\u4ed8\u5546\u6237\u5df2\u56fa\u5b9a\u4e3a\u4e24\u4e2a\u670d\u52a1\u5668\u7aef\u63a5\u53e3\uff0c\u540e\u53f0\u4ec5\u63d0\u4f9b\u53ea\u8bfb\u67e5\u770b\u3002',
  builtin: '\u5185\u7f6e',
  enabled: '\u5df2\u542f\u7528',
  disabled: '\u5df2\u505c\u7528'
};

function PaymentProviderManagement() {
  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await mallAPI.getPaymentProviderConfigs();
      const data = response.data?.data || {};
      setProviders(Array.isArray(data.builtin) ? data.builtin : []);
    } catch (error) {
      message.error(error.response?.data?.message || error.message || '\u8bfb\u53d6\u652f\u4ed8\u63a5\u53e3\u5931\u8d25');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const columns = [
    {
      title: '\u63a5\u53e3',
      dataIndex: 'name',
      render: (name, record) => (
        <div>
          <Text strong>{name || record.id}</Text>
          <div><Text type="secondary">ID: {record.id}</Text></div>
        </div>
      )
    },
    { title: '\u6765\u6e90', width: 105, render: () => <Tag color="blue">{T.builtin}</Tag> },
    { title: '\u5546\u6237\u53f7', dataIndex: 'merchant_id', width: 180, ellipsis: true },
    { title: '\u63a5\u53e3\u7c7b\u578b', dataIndex: 'api_style', width: 140, render: (value) => <Tag>{value}</Tag> },
    { title: '\u5e01\u79cd', dataIndex: 'currency', width: 80 },
    {
      title: '\u72b6\u6001',
      width: 90,
      render: (_, record) => (
        <Tag color={Number(record.enabled) === 1 ? 'success' : 'default'}>
          {Number(record.enabled) === 1 ? T.enabled : T.disabled}
        </Tag>
      )
    }
  ];

  return (
    <Card
      title={<Space><ApiOutlined />{T.title}</Space>}
      extra={<Button icon={<ReloadOutlined />} onClick={load} loading={loading} />}
    >
      <Alert type="info" showIcon message={T.subtitle} style={{ marginBottom: 16 }} />
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={providers}
        pagination={false}
        scroll={{ x: 760 }}
      />
    </Card>
  );
}

export default PaymentProviderManagement;
